import './App.css';
import {Grid} from "@mui/material";
import Pagina from "./Pagina/Pagina";

function App() {
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Pagina/>


        </Grid>
    );
}

export default App;
